import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import VueGecWxJssdk from '@/plugins/weixin/index'
import './assets/fontFamily/fonts.css'
import 'vant/lib/index.css'
import '@/plugins/rem.js'
Vue.use(VueGecWxJssdk)
Vue.use(Vant)
new Vue({ router, render: function (h) { return h(App) } }).$mount('#app')
